import Vuex, { GetterTree } from 'vuex';
import { PipelineState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<PipelineState, RootState> = {};

export default getters;
